var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"icon":"","dark":"","color":"color1"},on:{"click":_vm.add1Year}},[_vm._v("\n    1Y\n  ")]),_c('v-btn',{attrs:{"icon":"","dark":"","color":"color1"},on:{"click":_vm.add6Months}},[_vm._v("\n    6M\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }